module.exports = __webpack_public_path__ + "img/Operation_Single_Frame0001.0da6ead0.png";